import { colors } from 'theme'

export const defaultThemeStyles = {
    main: colors.blackLight,
    disable: colors.grey,
    active: colors.blackLight,
    light: colors.clouds,
}
